import React, { useEffect } from 'react';
import './RegistrationTab.css';

const RegistrationTab = () => {
  // Set page title when the registration tab is displayed
  useEffect(() => {
    document.title = 'Beach Bros - Registracija';

    return () => {
      document.title = 'Beach Bros';
    };
  }, []);

  return (
    <div className="registration-container">     
      <div className="registration-content">
        <div className="form-container">
          <iframe 
            src="https://forms.gle/ExygXzXqjPB35Wn8A?embedded=true" 
            width="100%" 
            height="750" 
            frameBorder="0" 
            marginHeight="0" 
            marginWidth="0"
            title="Registration Form"
            className="registration-form"
          >
            Loading form...
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default RegistrationTab;